import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAssessmentCommunications(assessmentId) {
  const response = await $.soap({
    body: {
      GetAssessmentCommunications: {
        $xmlns: 'http://dla.mil/ems/bpm/common/memo',
        AssessmentId: assessmentId
      }
    },
    blueprintArrays: ['GetAssessmentCommunicationsResponse.Memo'],
    blueprint: {
      communications: [
        'GetAssessmentCommunicationsResponse.Memo',
        {
          id: '$..ID',
          objectTypeId: '$..ObjectTypeID',
          objectId: '$..ObjectID',
          isCommunication: '$..IsCommunication',
          memo: '$..Memo',
          attachmentId: '$..AttachmentID',
          createdOn: '$..CreatedOn',
          createdBy: '$..CreatedBy',
          firstName: '$..FirstName',
          lastName: '$..LastName',
          fileName: '$..FileName'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.communications;
}
